"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

function e(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var r = e(require("ramda/src/mergeAll")),
    t = e(require("ramda/src/merge")),
    n = e(require("ramda/src/uncurryN")),
    c = e(require("ramda/src/flip")),
    u = require("redux-saga/effects"),
    o = require("redux"),
    a = require("react-redux"),
    s = e(require("ramda/src/applySpec")),
    i = e(require("ramda/src/mapObjIndexed")),
    f = require("react");

function p(e, t) {
  var n = Array.isArray(e) ? r(e) : e;
  return function (e, r) {
    void 0 === e && (e = t);
    var c = n[r.type];
    return "function" == typeof c ? c(e, r.payload) : e;
  };
}

var d = p;

function l(e, r) {
  return Array.isArray(e) ? e.reduce(function (e, n) {
    return t(e, n.reduce(r));
  }, {}) : e.reduce(r);
}

function x(e, r) {
  return Array.isArray(e) ? e.reduce(function (e, n) {
    return t(e, n.foldP(r));
  }, {}) : e.foldP(r);
}

var v = l,
    y = x;

function A() {
  return (A = Object.assign || function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];

      for (var n in t) {
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function m(e, r) {
  var t = (r ? r + "/" + e : e).replace(/(([a-z])([A-Z]))/g, function (e) {
    return e[0] + "_" + e[1];
  }).toUpperCase();
  return Object.assign(function (e, r) {
    return {
      error: r ? r.error : void 0,
      meta: r ? r.meta : void 0,
      payload: e,
      type: t
    };
  }, {
    type: t,
    reduce: function reduce(e) {
      var r;
      return (r = {})[t] = e, r;
    },
    reduceP: function reduceP(e) {
      var r;
      return (r = {})[t] = n(2, e), r;
    },
    fold: function fold(e) {
      var r;
      return (r = {})[t] = c(e), r;
    },
    foldP: function foldP(e) {
      var r;
      return (r = {})[t] = c(n(2, e)), r;
    }
  });
}

function b(e, r) {
  var t = m(e, r),
      n = {
    request: m(e + "_REQUEST", r),
    success: m(e + "_SUCCESS", r),
    failure: m(e + "_FAILURE", r),
    cancel: m(e + "_CANCEL", r)
  };
  return Object.assign(t, n);
}

var g = function g() {};

function h(e, r) {
  return i(function (r, t) {
    return "object" == typeof r ? h(e, r) : e(r, t);
  }, r);
}

g.action = function () {
  return function (e, r) {
    return m(e, r);
  };
}, g.asyncAction = function () {
  return function (e, r) {
    return b(e, r);
  };
};

var j = function j(e) {
  return function (r) {
    var t = o.compose(e, r);
    if (!function (e) {
      return r = e, ["request", "success", "failure", "cancel"].every(function (e) {
        return Object.prototype.hasOwnProperty.call(r, e);
      });
      var r;
    }(r)) return t;
    var n = r,
        c = {
      request: o.compose(e, n.request),
      success: o.compose(e, n.success),
      failure: o.compose(e, n.failure),
      cancel: o.compose(e, n.cancel)
    };
    return Object.assign(t, c);
  };
},
    q = function q(e) {
  return function (r) {
    return {
      actions: h(j(r), e)
    };
  };
},
    P = function P(e) {
  return s(e);
};

Object.defineProperty(exports, "connect", {
  enumerable: !0,
  get: function get() {
    return a.connect;
  }
}), Object.defineProperty(exports, "connectAdvanced", {
  enumerable: !0,
  get: function get() {
    return a.connectAdvanced;
  }
}), exports.CreateActionsAPI = g, exports.apiWorkerFactory = function (e, r, t) {
  return _regeneratorRuntime.mark(function n(c) {
    var o;
    return _regeneratorRuntime.wrap(function (n) {
      for (;;) {
        switch (n.prev = n.next) {
          case 0:
            return n.prev = 0, n.next = 3, u.put(e.request());

          case 3:
            if (void 0 !== c.payload) {
              n.next = 9;
              break;
            }

            return n.next = 6, u.call(r);

          case 6:
            n.t0 = n.sent, n.next = 12;
            break;

          case 9:
            return n.next = 11, u.call(r, c.payload);

          case 11:
            n.t0 = n.sent;

          case 12:
            if (o = n.t0, !t || !t.onSuccess) {
              n.next = 18;
              break;
            }

            return n.next = 16, u.fork(t.onSuccess, o, c);

          case 16:
            n.next = 20;
            break;

          case 18:
            return n.next = 20, u.put(e.success(o));

          case 20:
            n.next = 31;
            break;

          case 22:
            if (n.prev = 22, n.t1 = n.catch(0), !t || !t.onFailure) {
              n.next = 29;
              break;
            }

            return n.next = 27, u.fork(t.onFailure, n.t1, c);

          case 27:
            n.next = 31;
            break;

          case 29:
            return n.next = 31, u.put(e.failure(n.t1));

          case 31:
          case "end":
            return n.stop();
        }
      }
    }, n, null, [[0, 22]]);
  });
}, exports.applySelectors = P, exports.bindActionCreators = q, exports.composeReducers = function () {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++) {
    r[t] = arguments[t];
  }

  return function (e, t) {
    return r.reduce(function (e, r) {
      return r(e, t);
    }, e);
  };
}, exports.connectWithActions = function (e, r) {
  var t = "object" == typeof r ? P(r) : r;
  return a.connect(t, q(e));
}, exports.createAction = m, exports.createActions = function () {
  var e = 1 === arguments.length || arguments.length <= 0 ? void 0 : arguments[0],
      r = 1 === arguments.length ? arguments.length <= 0 ? void 0 : arguments[0] : arguments.length <= 1 ? void 0 : arguments[1],
      t = r(g);
  return Object.entries(t).reduce(function (r, t) {
    var n,
        c = t[0];
    return A({}, r, ((n = {})[c] = (0, t[1])(c, e), n));
  }, {});
}, exports.createAsyncAction = b, exports.createReducer = p, exports.fold = function (e, r) {
  return Array.isArray(e) ? e.reduce(function (e, n) {
    return t(e, n.fold(r));
  }, {}) : e.fold(r);
}, exports.foldP = x, exports.handleActions = d, exports.match = v, exports.matchF = y, exports.reduce = l, exports.reduceP = function (e, r) {
  return Array.isArray(e) ? e.reduce(function (e, n) {
    return t(e, n.reduceP(r));
  }, {}) : e.reduceP(r);
}, exports.useActions = function (e) {
  var r = a.useDispatch();
  return f.useMemo(function () {
    return q(e)(r).actions;
  }, [r, e]);
}, exports.useReduxState = function (e) {
  var r = f.useMemo(function () {
    return "object" == typeof e ? s(e) : e;
  }, [e]);
  return a.useSelector(r);
};